import { spinTheWheelTypes, spinWheelActionTypes } from '@/constants/types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleOpenSpinToWinModal,
  updateFakeSpinningTrack,
} from '@/redux/reducers/spin-the-wheel-reducer';
import { fetchSpinningResult } from '@/redux/thunk/spin-the-wheel-thunk';
import SpinTheWheelIconButton from './SpinTheWheelIconButton';
import SpinTheWheelBar from './SpinTheWheelBar';
import SpinNowButton from '../Button/SpinNowButton';

function SpinTheWheel({
  type = spinTheWheelTypes.icon,
  isOpenModal = false,
  disabled = false,
}) {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);

  const handleSpinTheWheel = (spinWheelActionType) => {
    if (spinWheelActionType === spinWheelActionTypes.openModal) {
      dispatch(handleOpenSpinToWinModal());
    } else if (spinWheelActionType === spinWheelActionTypes.spinningWheel) {
      if (isLoggedIn) {
        dispatch(fetchSpinningResult());
      } else {
        // console.log('open login->>>> showing blurry body');
        dispatch(updateFakeSpinningTrack(true));
      }
    }
  };

  switch (type) {
    case spinTheWheelTypes.icon:
      return <SpinTheWheelIconButton onSpin={handleSpinTheWheel} />;
    case spinTheWheelTypes.bar:
      return <SpinTheWheelBar onSpin={handleSpinTheWheel} />;
    case spinTheWheelTypes.button:
      return (
        <SpinNowButton
          onSpin={handleSpinTheWheel}
          isOpenModal={isOpenModal}
          disabled={disabled}
        />
      );

    default:
      return null;
  }
}

export default SpinTheWheel;
